import { useEffect, useState } from 'react';
import { IJob } from 'wisestep-api';
import { IUserDTO } from 'wisestep-base';

import { useUserContext } from '../../../context';
import { checkPermissionForJobAdminTeamOrCreatedUser } from '../../jobs/utils/JobListSideNavHelper';

const useJobUnassignPermission = (job: IJob | null) => {
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const [unAssignAllowed, setUnAssignAllowed] = useState(false);

  useEffect(() => {
    const fetchPermission = async () => {
      if (!job) {
        setUnAssignAllowed(false);
        return;
      }
      try {
        const res = await checkPermissionForJobAdminTeamOrCreatedUser(job, loggedInUser);
        setUnAssignAllowed(res);
      } catch (e) {
        console.error('Failed to check unassign permission:', e);
        setUnAssignAllowed(false);
      }
    };

    fetchPermission();
  }, [job, loggedInUser]);

  return { unAssignAllowed };
};

export default useJobUnassignPermission;
